import { render, staticRenderFns } from "./importVehicleDoc.vue?vue&type=template&id=122565f5&"
import script from "./importVehicleDoc.vue?vue&type=script&lang=js&"
export * from "./importVehicleDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports